import { useState } from 'react'
import { useSpaceStore } from '@/stores/spaceStore'
import Modal from '@/components/ui/Modal'
import { showToast } from '@/components/ui/Toast'
import styles from './JoinSpaceModal.module.css'

interface Props {
  open: boolean
  onClose: () => void
}

export default function JoinSpaceModal({ open, onClose }: Props) {
  const { joinSpace } = useSpaceStore()
  const [code, setCode] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    if (!code.trim()) { setError('请输入邀请码'); return }
    setError('')
    setLoading(true)
    try {
      await joinSpace(code.trim())
      showToast('已加入空间')
      setCode('')
      onClose()
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : '加入失败')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal open={open} onClose={onClose} title="加入空间">
      <div className={styles.form}>
        <input
          className={styles.input}
          placeholder="输入邀请码"
          value={code}
          onChange={e => { setCode(e.target.value); setError('') }}
          onKeyDown={e => { if (e.key === 'Enter' && code.trim()) handleSubmit() }}
        />
        {error && <div className={styles.error}>{error}</div>}
        <button
          className={styles.submitBtn}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? '加入中...' : '加入'}
        </button>
      </div>
    </Modal>
  )
}
